import React, { useState } from "react"
import {
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
} from "../../../components/elements/Table"
import {
  Anchor,
  Heading,
  Box,
  Text,
  Input,
  Image,
  Icon,
  Button,
} from "../../../components/elements"
import _ from "lodash"
import { Avatar, Flex, Grid } from "@chakra-ui/react"
import formatDateHelper from "../../../utils/formatDate"

const thead = [
  "ID",
  "Name",
  "Email",
  "Account ID",
  "Amount",
  "Curr. Balance",
  "IB Code",
  "Status",
  "Comment",
  "Created At",
  "",
]
// {req: {}, status}
const DepositTable = ({ requests, onChangeStatus }) => {
  return (
    <Box className="mc-table-responsive">
      <Table className="mc-table product">
        <Thead className="mc-table-head primary">
          <Tr>
            {thead.map((item, index) => (
              <Th key={index}>{item}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody className="mc-table-body even">
          {requests?.length ? (
            <>
              {_.map(requests, (_r) => {
                return (
                  <Tr key={_r?.id}>
                    <Td> # {_r?.id} </Td>
                    <Td>{_r?.name} </Td>

                    <Td>{_r?.email} </Td>
                    <Td>{_r?.ib_login} </Td>
                    <Td>{_r?.amount} </Td>
                    <Td>{_r?.commission ?? 0} </Td>
                    <Td>{_r?.ib_code ?? "-"} </Td>
                    <Td>{_r?.transaction_status ?? "-"} </Td>

                    <Td>{_r?.comment ?? "-"} </Td>
                    <Td>
                      {_r?.created_at ? formatDateHelper(_r?.created_at) : "-"}{" "}
                    </Td>
                    <Td>
                      {_r?.transaction_status === "PENDING" ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <button
                            onClick={() => {
                              onChangeStatus({
                                ..._r,
                                status: "ACCEPTED",
                              })
                            }}
                            className="mc-btn primary sm mr-2 ml-auto"
                          >
                            Accept
                          </button>
                          &nbsp; &nbsp;
                          <button
                            onClick={() => {
                              onChangeStatus({
                                ..._r,
                                status: "REJECTED",
                              })
                            }}
                            className="mc-btn red  sm"
                          >
                            Reject
                          </button>
                        </div>
                      ) : null}
                    </Td>
                  </Tr>
                )
              })}
            </>
          ) : (
            <Tr>
              <Td colSpan={thead?.length ?? 1}>
                <div style={{ textAlign: "center", width: "100%" }}>
                  No Data found
                </div>
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Box>
  )
}

export default DepositTable
